var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('BaseModal',{ref:"BaseModal",attrs:{"title":"Adicionar job combo"}},[_c('Ticket',{ref:"Ticket",attrs:{"embed":true,"no_footer":false,"no_header":true},on:{"saved":_vm.confirm}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }